import { motion } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";
import PageShell from "@/components/PageShell";
import { IMAGES } from "@/lib/config";

export default function ChiSiamo() {
  return (
    <PageShell testid="chi-siamo-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16 md:py-24 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <span className="text-brand-gold font-semibold tracking-[0.2em] uppercase text-sm">Chi siamo</span>
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-brand-ink mt-4 mb-7">
            Tre generazioni di ristrutturazioni a Napoli
          </h1>
          <div className="text-brand-slate/75 text-lg leading-relaxed space-y-5">
            <p>
              Il brand <strong>Ristrutturare Casa Napoli</strong> è della ditta <strong>Multiservice la Fenice S.R.L.s</strong>,
              operante nel campo delle ristrutturazioni da ben 3 generazioni. Operiamo su Napoli e provincia e ci
              avvaliamo dei migliori professionisti per poter assicurare ai nostri clienti la cosa a cui tengono di più:
              la puntualità e il rispetto delle tempistiche.
            </p>
            <p>
              Il nostro modo di lavorare è semplice e trasparente: garanzie scritte, tempi certi, assistenza continua
              e interventi rapidi e organizzati. Nessun aumento improvviso, nessuna promessa che non possiamo mantenere.
              <strong> Facciamo ciò che promettiamo e promettiamo ciò che facciamo.</strong>
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 mt-9">
            <a
              href="/#preventivo"
              data-testid="chisiamo-preventivo-cta"
              className="group inline-flex items-center justify-center gap-2 bg-brand-gold hover:bg-brand-goldDark text-brand-ink font-bold px-8 py-4 rounded-full transition-colors"
            >
              Calcola il preventivo online
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="/contatti"
              data-testid="chisiamo-contatti-cta"
              className="inline-flex items-center justify-center gap-2 border border-brand-ink/20 hover:border-brand-ink text-brand-ink font-semibold px-8 py-4 rounded-full transition-colors"
            >
              <MessageCircle size={18} /> Contattaci
            </a>
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.7 }}
          className="relative"
        >
          <img src={IMAGES.living} alt="Ambiente ristrutturato a Napoli" className="rounded-2xl w-full h-[500px] object-cover shadow-xl" />
        </motion.div>
      </section>
    </PageShell>
  );
}
